import React from "react";
import {
  CollateralStrategyType,
  VirtualOmsEventLogRow,
} from "src/VirtualOMS/types/collateral";
import { formatVirtualOmsDateTime } from "src/VirtualOMS/formatDateTime";

interface Props {
  rows: VirtualOmsEventLogRow[];
}

const EventLogTable: React.FC<Props> = ({ rows }) => (
  <div className="overflow-x-auto p-4">
    <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700">
      <thead className="bg-gray-100 text-xs uppercase">
        <tr>
          <th className="border px-4 py-2">Requested At</th>
          <th className="border px-4 py-2">Operation</th>
          <th className="border px-4 py-2">Account</th>
          <th className="border px-4 py-2">Strategy</th>
          <th className="border px-4 py-2">Symbols</th>
          <th className="border px-4 py-2">Delta</th>
          <th className="border px-4 py-2">Quantity</th>
          <th className="border px-4 py-2">Chance</th>
          <th className="border px-4 py-2">Result</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr className="hover:bg-gray-50" key={`${row.requestedAt}-${row.operation}-${index}`}>
            <td className="border px-4 py-2">{formatRequestedAt(row.requestedAt)}</td>
            <td className="border px-4 py-2">{row.operation}</td>
            <td className="border px-4 py-2">{row.accountName}</td>
            <td className="border px-4 py-2">
              {row.strategyType === CollateralStrategyType.BullCall || row.strategyType === "BullCall"
                ? "Bull Call"
                : row.strategyType === CollateralStrategyType.CoveredCall || row.strategyType === "CoveredCall"
                  ? "Covered Call"
                  : "-"}
            </td>
            <td className="border px-4 py-2">
              {[row.collateralSymbolName || row.collateralSymbolIsin, row.baseSymbolName || row.baseSymbolIsin]
                .filter(Boolean)
                .join(" / ") || "-"}
            </td>
            <td className="border px-4 py-2">{row.quantityDelta ?? "-"}</td>
            <td className="border px-4 py-2">{row.quantity ?? "-"}</td>
            <td className="border px-4 py-2">{row.chanceRefId ?? "-"}</td>
            <td className="border px-4 py-2">{row.result}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const formatRequestedAt = formatVirtualOmsDateTime;

export default EventLogTable;
